import * as React from 'react';
import Head from 'components/Head';

const terms = () => {
  return (
    <>
      <Head title="Terms & Conditions" description="Terms & Conditions" useCurrentUrl />

      <div>
        <div>Full legal terms coming soon.</div>
        <div>
          The entirety of the website is copyrighted. Do not sell or distribute the content. You are
          only allowed to access the content through the platform.
        </div>
      </div>
    </>
  );
};

export default terms;
